export default function Lineup() {
  return (
    <section id="lineup" className="w-full bg-[#2e3b0e] py-16 px-4">
      <div className="max-w-5xl mx-auto">
        {/* Section title */}
        <h2 className="font-['Londrina_Solid'] text-[#c8e04a] text-5xl md:text-6xl tracking-widest uppercase text-center mb-10">
          Lineup
        </h2>

        {/* Divisore */}
        <div className="flex items-center justify-center gap-4 mb-10">
          <div className="h-px flex-1 bg-[#c8e04a]/30" />
          <div className="w-2 h-2 rounded-full bg-[#c8e04a]" />
          <div className="h-px flex-1 bg-[#c8e04a]/30" />
        </div>

        {/* Box immagine lineup */}
        <div className="w-full flex items-center justify-center overflow-hidden rounded-lg">
          <img
            src="https://static.readdy.ai/image/2500ac09d0252d19a03ba42d5ab6c3f1/7af80d2a448f2d724bb3b3759d5e4803.png"
            alt="Lineup Festa della Tammorra 2026"
            className="w-full h-auto object-contain"
          />
        </div>
      </div>
    </section>
  );
}
